import { render } from "./Gradient.vue?vue&type=template&id=cc29e1b8"
import script from "./Gradient.vue?vue&type=script&lang=js"
export * from "./Gradient.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__